import { Column, Img, Link, Row, Text } from "@react-email/components";
import type { WalletBlockProps } from "./types";
import { tLayout } from "../../translations";


export function WalletEmailRenderer({
  block,
  locale,
  appleWalletURL,
  googleWalletURL,
  shop,
  isEditor,
}: WalletBlockProps & { isEditor?: boolean }) {
  const t = tLayout(locale, "en");
  const appleWalletImageUrl = `https://baback-wallet.s3.eu-west-3.amazonaws.com/apple-buttons/${getImageLocale(locale)}`;
  const googleWalletImageUrl = `https://baback-wallet.s3.eu-west-3.amazonaws.com/google-buttons/${getImageLocale(locale)}`;
  const alignment = block.alignment;

  const alignStyle = {
    left: "left",
    center: "center",
    right: "right",
  }[alignment] as "left" | "center" | "right";
  const isAppleWalletEnabled = isEditor
    ? shop.trackingPreferences.isAppleWalletEnabled
    : !!appleWalletURL?.length && !appleWalletURL.includes("undefined") && shop.trackingPreferences.isAppleWalletEnabled;
  const isGoogleWalletEnabled = isEditor
    ? shop.trackingPreferences.isGoogleWalletEnabled
    : !!googleWalletURL?.length && !googleWalletURL.includes("undefined") && shop.trackingPreferences.isGoogleWalletEnabled;

  if (!isAppleWalletEnabled && !isGoogleWalletEnabled) {
    if (isEditor) {
      return (
        <Row>
          <Column align={alignStyle}>
            <div
              style={{
                backgroundColor: "#FEF3C7",
                border: "1px solid #FCD34D",
                borderRadius: "6px",
                padding: "12px 16px",
                margin: "8px 0",
              }}
            >
              <Text
                style={{
                  color: "#92400E",
                  fontSize: "14px",
                  lineHeight: "1.5",
                  margin: "0",
                }}
              >
                ⚠️ {t("wallet.warningNotEnabled")}
              </Text>
            </div>
          </Column>
        </Row>
      );
    }
    return null;
  }

  return (
    <Row>
      <Column align={alignStyle}>
        <div style={{ display: "inline-block", textAlign: alignStyle }}>
          {isAppleWalletEnabled &&
						<Link
							href={appleWalletURL}
							style={{
                display: "inline-block",
                margin: "4px",
                verticalAlign: "middle",
              }}
						>
							<Img
								src={appleWalletImageUrl}
								alt="Add to Apple Wallet"
								height="40"
								style={{ height: "40px", display: "block", maxWidth: "100%" }}
							/>
						</Link>
          }
          {isGoogleWalletEnabled &&
						<Link
							href={googleWalletURL}
							style={{
                display: "inline-block",
                margin: "4px",
                verticalAlign: "middle",
              }}
						>
							<Img
								src={googleWalletImageUrl}
								alt="Add to Google Wallet"
								height="40"
								style={{ height: "40px", display: "block", maxWidth: "100%" }}
							/>
						</Link>
          }
        </div>
      </Column>
    </Row>
  );
}


function getImageLocale(locale: string) {
  return ['fr', 'en', 'es', 'de'].includes(locale) ? locale : 'en';
}
